import { combineReducers } from '@reduxjs/toolkit';
import { headerSlices } from '@carnica/smart-kit';

import cart from './cart';
import common from './common';

export const specialProjectHeader = combineReducers({
  ...headerSlices,
  cart,
  common,
});
